// LinkAnim
export default class LinkAnim {
  constructor() {
    this.links = document.querySelectorAll('.js-link-anim')
    this.init()
  }
  init() {
    this.setLink()
  }

  setLink() {
    this.links.forEach(function (targetLink) {
      // テキスト全体を span 要素で囲む
      var span = document.createElement('span')
      span.innerHTML = targetLink.innerHTML
      span.classList.add('c-link-anim') // 必要なクラスやスタイリングを適用

      // 元の要素を span 要素で置き換える
      targetLink.innerHTML = ''
      targetLink.appendChild(span)
    })
  }
}
